import EquipmentsSystem from './EquipmentsSystem';

export default EquipmentsSystem;
